export enum TemplateBodyType {
  PLAINTEXT = 'plaintext',
  HTML = 'html',
}
